import React from "react";
import * as Sentry from "@sentry/react";
import DefaultEvents from "avo/events/global";
import FlexBox from "schoolUiComponents/basic/Box/FlexBox";
import Text from "schoolUiComponents/basic/Text";
import Button from "schoolUiComponents/basic/Button";

const fallbackUI = (
    <FlexBox justifyContent="center" alignItems="center">
        <Text.NORMAL>
            {"Uh-oh! Something went wrong. "}
            <Button
                dataTestId="error-boundary-refresh-btn"
                onClick={() => window.location.reload()}
            >
                Refresh this page
            </Button>
            {" or try again later."}
        </Text.NORMAL>
    </FlexBox>
);

/**
 * [AI GENERATED CODE]
 * Wraps Sentry.ErrorBoundary with project fallback UI and analytics.
 * Props:
 *   children  — required
 *   onError   — optional (eventId: string | null) => void, for entry-point-specific side effects
 */
const ErrorBoundary = ({ children, onError = () => {} }) => (
    <Sentry.ErrorBoundary
        fallback={fallbackUI}
        onError={(error, componentStack, eventId) => {
            DefaultEvents.ErrorMessageDisplayedB2b(JSON.stringify({
                eventId,
                error: error?.message,
                stack: error?.stack,
                componentStack,
            }));
            if (onError) {
                onError(eventId);
            }
        }}
    >
        {children}
    </Sentry.ErrorBoundary>
);

export default ErrorBoundary;
